// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store/'
import Router from 'vue-router'
Vue.use(Router)
import { Swiper, EffectFade,EffectCube,Pagination,Autoplay } from 'swiper';
import VueAwesomeSwiper from 'vue-awesome-swiper';

import 'swiper/swiper-bundle.css';
import H5Cropper from 'vue-cropper-h5'
Vue.use(H5Cropper)

Swiper.use([EffectFade,EffectCube,Pagination,Autoplay]);
Vue.use(VueAwesomeSwiper);
import fileupload from './components/fileupload.vue'
Vue.component('fileupload', fileupload);
import fileuploadraw from './components/fileuploadraw.vue'
Vue.component('fileuploadraw', fileuploadraw);
import areaanim from './components/areaanim.vue'
Vue.component('areaanim', areaanim);
import divanim from './components/divanim.vue'
Vue.component('divanim', divanim);
import audioui from './components/audioui.vue'
Vue.component('audioui', audioui);
import loadui from './components/loadui.vue'
Vue.component('loadui', loadui);
import starui from './components/starui.vue'
Vue.component('starui', starui);
import swipermoban from './components/swipermoban.vue'
Vue.component('swipermoban', swipermoban);
import yuimg from './components/yuimg.vue'
Vue.component('yuimg', yuimg);
import yuimg1 from './components/yuimg1.vue'
Vue.component('yuimg1', yuimg1);
import yuimg2 from './components/yuimg2.vue'
Vue.component('yuimg2', yuimg2);
import commonmokuai from './components/commonmokuai.vue'
Vue.component('commonmokuai', commonmokuai);
import xuliezhen from './components/xuliezhen.vue'
Vue.component('xuliezhen', xuliezhen);
import xialaanim from './components/xialaanim.vue'
Vue.component('xialaanim', xialaanim);
import selects from './components/selects.vue'
Vue.component('selects', selects);
import hecheng from './components/hecheng.vue'
Vue.component('hecheng', hecheng);
import p2 from './components/p2.vue'
Vue.component('p2', p2);
import p3 from './components/p3.vue'
Vue.component('p3', p3);
import p4 from './components/p4.vue'
Vue.component('p4', p4);
import p5 from './components/p5.vue'
Vue.component('p5', p5);
import p6 from './components/p6.vue'
Vue.component('p6', p6);
// import p4 from './components/p4.vue'
// Vue.component('p4', p4);
// import p5 from './components/p5.vue'
// Vue.component('p5', p5);
// import p6 from './components/p6.vue'
// Vue.component('p6', p6);
// import p7 from './components/p7.vue'
// Vue.component('p7', p7);
// import * as PIXI from 'pixi.js'
Vue.config.productionTip = false
/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js